<template>
  <div>
  <div class="bsSelection"
      v-if="(selection && ((currentBetSlipState<1) || ((tab=='REGULAR' && betTypeStakes[selection.idfoselection]) || tab=='RR-' || tab=='TEASER-')))"
      :class="[tab, 'id-'+selectionId, isFor, 'sport-'+sport, {multiSingles: multiSingles,
    mixedTeasers: mixedTeasers,
    inRefferalStakeChanged: inRefferalStakeChanged && currentBetSlipState==6,
    priceUp:((priceUp || (tab=='TEASER' && hcpUp)) && !(isclosed || issuspended || isNr)),
    priceDown: ((priceDown || (tab=='TEASER' && hcpDown)) && !(isclosed || issuspended || isNr)),
    isClosed: isclosed,
    isSuspended: issuspended,
    isNR: isNr,
    hliteNew: (hliteNew && !(isclosed || issuspended || isNr)),
    hcpUp: hcpUp,
    hcpDown: hcpDown,
    optedOut: (tab=='RR' && !selectedObj[id]) || (tab=='TEASER' && !selectedObj[id]),
    edit: currentBetSlipState==0,
    review: currentBetSlipState==1,
    changed: !isclosed && !issuspended && !isNr && (priceUp || priceDown || hcpUp || hcpDown)
    },
    'state-'+currentBetSlipState,
    interRelatedClass]">
    <!--@mousedown="start" @mouseleave="stop" @mouseup="stop" @touchstart="start" @touchend="stop" @touchcancel="stop"-->
    <h2 class="header-SING" v-show="tab=='REGULAR' && currentBetSlipState>=1">
      {{ $t('BetSlip.tab.title.SINGLE') }}
    </h2>
    <div class="selection">
      <div class="header-changed msg info" v-if="!isclosed && !issuspended && (priceUp || priceDown || hcpUp || hcpDown)">
        <icon name="icon-information" colorName="blue"></icon>
        <span>
          <div v-if="priceUp">{{ $t('BetSlip.selection.changed.priceUp') }}</div>
          <div v-if="priceDown">{{ $t('BetSlip.selection.changed.priceDown') }}</div>
          <div v-if="hcpUp">{{ $t('BetSlip.selection.changed.hcpUp') }}</div>
          <div v-if="hcpDown">{{ $t('BetSlip.selection.changed.hcpDown') }}</div>
        </span>
      </div>
      <div class="event-name" v-if="tab=='REGULAR'">
        <div class="bs_left">
          <icon v-if="selection.idfosporttype" :name="'icon-' + selection.idfosporttype.split(' ').join('').toLowerCase()"></icon>
          <span class="eventname" >
          <span>{{formatSelectionName(selection)}}</span>
            <!-- <span>{{wbr(market.eventname, 0)}}</span>
            <span>{{wbr(market.eventname, 1)}}</span> -->
            <span class="currenthandicap" v-if="selection && selection.currenthandicap">{{ formatHandicap(selection)}}</span>
          </span>
        </div>
        <div class="bs_right">
          <span class="selection-ts" v-if="false && tab=='REGULAR' && !isLive && market.tsstart && currentBetSlipState<1" >
                <span class="time">{{ market.tsstart | moment(dateFormats.longTime) }}</span>
                <span class="date">{{ market.tsstart | moment(dateFormats.shortDate) }}</span>
          </span>
          <div class="market-name">{{market.name}}</div>
          <button class="btnX" @click="removeSelection(selection)" v-if="tab=='REGULAR' && currentBetSlipState<1">
              <icon name="icon-trash" colorName="red"></icon>
          </button>
          <button class="btnToggleVisibility" @click="toggleBetVisibility">
            <icon :name="betVisibility ? 'icon-chevron-down' : 'icon-chevron-top'" colorName="red"></icon>
          </button>
        </div>
      </div>
      <vue-slide-up-down :active="betVisibility" :duration="500">
        <div class="columns">
          <div class="column column-left" >
            <span class="isLive" v-if="isLive && tab!='RR'"><span>{{ $t('BetSlip.selection.isLive') }}</span></span>
            <v-checkbox type="checkbox" v-if="tab!='REGULAR' && showCheckbox === true" :id="id.toString()" :value="selectedObj[id]"
                  :disabled="currentBetSlipState>=1"
                  v-model="selectedObj[id]" @change="updateSelected(sport)">
            </v-checkbox>
            <span class="icon" v-if="((tab=='TEASER' && mixedTeasers) || tab=='RR') && showCheckbox === false">
                <icon :name="'icon-' + market.idfosporttype.split(' ').join('').toLowerCase()" ></icon>
            </span>
          </div>
          <div class="column column-right" @click="toggleOptedIn(sport)" >
              <label :for="id">
                <div class="selection-data">
                  <div class="event-name-inner" v-if="tab!='REGULAR'">
                    <span class="name">
                      <span class="eventname" :class="{'teaser-icon-shifted':mixedTeasers && tab=='TEASER' && currentBetSlipState>0}" >
                        <span>{{formatSelectionName(selection)}}</span>
                        <span class="currenthandicap" v-if="selection && selection.currenthandicap">{{ formatHandicap(selection)}}</span>
                      </span>
                    </span>
                    <div class="selection-price" v-if="tab!=='TEASER' && tab!=='REGULAR'" >
                      <!--<div>{{selection.price}}</div>-->
                      <span class="price">
                        <span v-if="!isclosed && !issuspended && !isNr">{{ formatSelectionPrice(selection)}}</span>
                        <span v-if="isclosed || issuspended || isNr">
                          <span class="price_title" v-if="isclosed">{{ $t('BetSlip.selection.isClosed') }}</span>
                            <span class="price_title" v-if="issuspended">{{ $t('BetSlip.selection.isSuspended') }}</span>
                            <span class="price_title" v-if="isNr">{{ $t('BetSlip.selection.isNr') }}</span>
                          </span>
                      </span>
                    </div>
                    <div class="selection-price" v-if="tab=='TEASER'" >
                      <span class="price" v-if="!isclosed && !issuspended && !isNr">
                        {{ selectedTeaser[sport] && formatHandicap(teasers[selectedTeaser[sport]][selection.idfoselection])}}
                      </span>
                      <span v-if="isclosed || issuspended || isNr">
                        <span class="price_title" v-if="isclosed">{{ $t('BetSlip.selection.isClosed') }}</span>
                        <span class="price_title" v-if="issuspended">{{ $t('BetSlip.selection.isSuspended') }}</span>
                        <span class="price_title" v-if="isNr">{{ $t('BetSlip.selection.isNr') }}</span>
                      </span>
                    </div>
                  </div>
                  <div class="selection-name">
                    <span class="name">
                    <span>{{wbr(market.eventname, 0)}}</span>
                    <span>{{wbr(market.eventname, 1)}}</span>
                    <!-- <span v-if="market.BB" class="available-for-bb"></span> -->
                    </span>
                    <span class="isLive" v-if="isLive && tab!='REGULAR'"><span>{{ $t('BetSlip.selection.isLive') }}</span></span>
                  </div>
                  <div v-if="tab!='REGULAR'" class="market-name">{{market.name}}</div>
                </div>
              </label>
          </div>
        </div>
        <div v-if="tab=='REGULAR'" class="stake_price">
          <span v-if="!isclosed && !issuspended && !isNr" class="price">
            <span class="price_title">{{ $t('BetSlip.oddsprice') }}</span>
            <span>{{ formatSelectionPrice(selection)}}</span>
          </span>
          <span v-if="isclosed || issuspended || isNr" class="price">
          <span class="price_title" v-if="isclosed">{{ $t('BetSlip.selection.isClosed') }}</span>
            <span class="price_title" v-if="issuspended">{{ $t('BetSlip.selection.isSuspended') }}</span>
            <span class="price_title" v-if="isNr">{{ $t('BetSlip.selection.isNr') }}</span>
          </span>
          <stake-and-return
            :id="selection.idfoselection"
            :perType="'PerSelection'"
            :inRefferalStakeChanged="inRefferalStakeChanged && currentBetSlipState==6"
            :stakeChange="stakeChange"
          >
          </stake-and-return>
        </div>
      </vue-slide-up-down>
    </div>
  </div>
  </div>
</template>

<script>
  //  import { mapGetters } from 'vuex'
  import Vue from 'vue'
  import store from '@/store'
  import priceFormat from '@/library/priceFormat'
  import stakeAndReturn from './stakeNreturn.vue'
  import Icon from '@/components/common/Icon'
  import BettingOffer from '@/components/mixins/BettingOffer'
  import VueSlideUpDown from 'vue-slide-up-down'

  export default {
    props: ['selectionId', 'tab', 'betTypeStakes', 'betTypeStakesPerBetType', 'allowedBetTypesAndReturns', 'winnings', 'multiSingles', 'multiSinglesStake', 'currentBetSlipState', 'isLive', 'sport', 'selectedTeaser', 'teasers', 'isFor', 'showInterRelated', 'mixedTeasers'],

    data () {
      return {
        timeOut: null,
        intKillHlite: null,
        killHliteAfter: 5,
        hliteNew: !true,
        priceUp: false,
        priceDown: false,
        hcpUp: false,
        hcpDown: false,
        stateLimitToUpdate: 2,
        inRefferalStakeChanged: false,
        stakeChange: {old: 0, new: 0},
        betVisibility: true
      }
    },

    components: {
      stakeAndReturn,
      Icon,
      VueSlideUpDown
    },

    mixins: [
      BettingOffer
    ],

    computed: {
      id () {
        return this.selectionId
      },
      idfomarket () {
        return store.getters['sbBetslipState/getIdfoMarketById'](this.id)
      },
      idfoevent () {
        return store.getters['sbBetslipState/getIdfoEventById'](this.id)
      },
      selection () {
        return this.id ? store.getters['sbBetslipState/getStoredSelectionById'](this.id) : {}
      },
      liveSelection () {
        return this.id && this.selection ? store.getters['sbBetslipState/getSelectionById'](this.id, true) : {}
      },
      isForTeaser () {
        return this.id && this.selection ? store.getters['sbBetslipState/isForTeaser'](this.selection) : false
      },
      clearMarkings () {
        return store.getters['sbBetslipState/clearMarkings']
      },
      interRelated () {
        return store.getters['sbBetslipState/interRelated'][this.id]
      },
      placeholder () {
        return {
          wager: this.$t('BetSlip.input.placeholder.wager'),
          return: this.$t('BetSlip.input.placeholder.return')
        }
      },
      interRelatedClass () {
        return this.interRelated && (this.tab !== 'TEASER' || (this.tab === 'TEASER' && this.showInterRelated)) ? 'interRelated-' + this.interRelated : 'noInterRelated'
      },
      stake () {
        return this.betTypeStakes[this.id]
      },
      price () {
        var selection = this.liveSelection
        var price = selection && selection.price ? selection.price * 1 : ''
        if (this.currentBetSlipState > 1 && this.allowedBetTypesAndReturns && this.allowedBetTypesAndReturns.PotentialReturns) {
          var potentialReturn = this.allowedBetTypesAndReturns.PotentialReturns.PerSelection &&
            this.allowedBetTypesAndReturns.PotentialReturns.PerSelection[this.id] &&
            this.allowedBetTypesAndReturns.PotentialReturns.PerSelection[this.id].PotentialReturn
          price = parseFloat((potentialReturn * 1).toFixed(2))
        }
        return price
      },
      priceLocal () {
        var priceLocal = this.selection && this.selection.price
        if (this.selection && this.selection.currentpricedown && this.selection.currentpriceup) {
          priceLocal = this.formatSelectionPrice(this.selection)
        }
//        console.log('priceLocal: ' + priceLocal)
        return priceLocal
      },
      nr () {
//        return this.selection && this.selection.isclosed
        var selection = this.isLive ? !this.liveSelection : this.selection
        return selection && selection.idfobolifestate && selection.idfobolifestate === 'NR'
      },
      closed () {
//        return this.selection && this.selection.isclosed
        return this.isLive ? !this.marketLive : this.selection && this.selection.isclosed
      },
      suspended () {
//        return this.selection && !this.selection.isclosed && !this.selection.istradable
        return this.isLive ? this.marketLive && !this.marketLive.istradable : this.selection && !this.selection.isclosed && !this.selection.istradable
      },
      isNr () {
        return this.selection && this.selection.idfobolifestate && this.selection.idfobolifestate === 'NR'
      },
      isclosed () {
        return this.selection && this.selection.isclosed
      },
      issuspended () {
        return this.selection && !this.selection.isclosed && !this.selection.istradable
      },
      priceUp_ () {
        return this.selection && this.selection.priceUp
      },
      priceDown_ () {
        return this.selection && this.selection.priceDown
      },
      currenthandicap () {
        var selection = this.liveSelection
        /*
        var hcp = selection && selection.currenthandicap
        return hcp ? hcp * 1 : hcp
        */
        return this.formatHandicap(selection)
      },
      currenthandicapLocal () {
        /*
        var hcp = this.selection && this.selection.currenthandicap
        return hcp ? hcp * 1 : hcp
        //
        */
        return this.formatHandicap(this.selection)
      },
      marketLive () {
        return this.id ? store.getters['sbBetslipState/getMarketById'](this.id) : {}
      },
      market () {
        return this.id && this.selection ? store.getters['sbBetslipState/getStoredMarketById'](this.id) : {}
      },
      selectedObj: {
        // getter
        get: function () {
          if (this.tab === 'RR') {
            return store.getters['sbBetslipState/optedInRR']
          }
          if (this.tab === 'TEASER') {
            return store.getters['sbBetslipState/optedInTeaser']
          }
          return {}
        },
        // setter
        set: function (newValue) {
//          console.log('selected newValue: ' + newValue)
        }
      },
      inRefferal () {
        return store.getters['sbBetslipState/inRefferal']
      },
      isLivePush () {
        return store.getters['livebettingState/liveBettingDataSourceType'] === 'PUSH'
      },
      showCheckbox () {
        return window.ctsautoconf.BETSLIP_CHECKBOXES
      }
    },

    methods: {
      toggleBetVisibility () {
        this.betVisibility = !this.betVisibility
      },

      toggleOptedIn (sport) {
//        console.log('toggleOptedIn: ' + sport)
//        console.log('showCheckbox: ' + this.showCheckbox)
//        console.log('toggleOptedIn ' + this.tab)
        if (this.showCheckbox && this.tab !== 'REGULAR') {
          this.selectedObj[this.id] = !this.selectedObj[this.id]
          this.updateSelected(sport)
        }
      },

      updateSelected (sport) {
//        console.log('updateSelected')
        store.commit('sbBetslipState/dismissErrorFromSelection', false)
        if (this.tab === 'TEASER') {
//          console.log('teaser selection updateSelected')
          this.$emit('updateSelected', sport)
        } else {
          this.$emit('updateSelected', false)
          store.dispatch('sbBetslipState/getAllowedBetTypesAndReturns')
        }
      },
      removeSelection () {
//        console.log('Emit removeSelection')
        this.$emit('removeSelection', this.selection)
      },
      formatHandicap (selection) {
//        console.log('formatHandicap')
        var h = selection && (selection.currenthandicap || selection.currentmatchhandicap || selection.Handicap)
        h = typeof h !== 'undefined' && !isNaN(h) ? parseFloat(h) : ''
//        var h = selection.currenthandicap && !isNaN(selection.currenthandicap) ? parseFloat(selection.currenthandicap) : ''
        if (h !== '' && !isNaN(h)) {
          if (selection.hadvalue === 'A') {
            if (h) {
              h *= -1
            }
          }
          if (selection.hadvalue === 'H' || selection.hadvalue === 'D' || selection.hadvalue === 'A') {
            if (h >= 0) {
              h = '+' + h
            }
          }
        }
        return h
      },
      formatSelectionName (selection) {
        if (selection && selection.name) {
          return Array.isArray(selection.name) ? selection.name[0] : selection.name
        } else {
          return ''
        }
      },
      formatSelectionPrice (selection) {
        return priceFormat.formatSelectionPrice(selection)
      },
      formatOdds (betType) {
        var odds = betType.PotentialReturn - betType.UnitCount + 1
        var formatted = priceFormat.formatOdds(odds, 2)
        return formatted
      },
      formatPrice (v) {
        return priceFormat.formatOdds(v, 0)
      },
      priceNum (price, noPrecision) {
        if (price) {
          if (typeof price === 'string') {
            price = parseFloat(price)
          }
          if (!noPrecision) {
            price = parseFloat(price.toFixed(2))
          }
        }
        return price
      },
      updateStake (val) {
        this.selection.stake += val
      },
      killNewHlite () {
        this.hliteNew = false
//        store.commit('sbBetslipState/killHlite', this.selection.idfoselection)
      },

      askToRemove () {
        var self = this
        var r = confirm('Remove selection?')
//        console.log('Remove selection: ' + r)
        if (r) {
          self.removeSelection()
        }
      },

      start () {
        var self = this
        clearTimeout(this.timeOut)
        this.timeOut = setTimeout(function () {
          self.askToRemove()
        }, 1000)
      },
      stop () {
        clearTimeout(this.timeOut)
      },
      wbr (input, id) {
        var i
        var separator
        var separators = ['@', 'v', 'V', 'vs', 'VS', 'Vs', 'At', 'at', 'v.', 'V.', 'vs.', 'VS.', 'Vs.', '-']
        var parts = []
        for (i = 0; i < separators.length; i++) {
          separator = separators[i]
          parts = input ? input.split(' ' + separator + ' ') : []
          if (parts.length === 2) {
            parts[0] += ' ' + separator + ' '
            break
          }
        }
        return parts[id] || ''
      }
    },

    watch: {
      stake (newVal, oldVal) {
//        console.log('Selection Stake changed: ' + oldVal + ' -> ' + newVal)
        this.stakeChange = {old: oldVal || 0, new: newVal}
        this.inRefferalStakeChanged = this.inRefferal
      },
      clearMarkings (clear) {
//        console.log('Watch: clearMarkings: ' + clear)
        var self = this
        if (clear) {
          self.priceUp = false
          self.priceDown = false
          self.hcpUp = false
          self.hcpDown = false
        }
      },
      priceLocal (newVal, oldVal) {
        var doUpdate = false
//        console.log('WATCHER: selection.priceLocal: ' + oldVal + ' => ' + newVal)
        newVal = this.priceNum(newVal, !true)
        oldVal = this.priceNum(oldVal, !true)
//        console.log('WATCHER: selection.priceLocal: ' + oldVal + ' => ' + newVal)
        if (newVal > oldVal) {
          doUpdate = true
          this.priceUp = this.tab !== 'TEASER' && true
          this.priceDown = false
        } else if (newVal < oldVal) {
          doUpdate = true
          this.priceUp = false
          this.priceDown = this.tab !== 'TEASER' && true
        } else {
          this.priceUp = false
          this.priceDown = false
        }
        if (doUpdate && this.currentBetSlipState < this.stateLimitToUpdate && this.tab !== 'TEASER') {
          store.dispatch('sbBetslipState/setBetSlipChange', {key: 'price', id: this.selectionId})
        }
      },
      price (newVal, oldVal) {
//        console.log('watcher price liveSelection:')
        if (this.tab === 'TEASER') {
          return
        }
        var doUpdate = false
//        console.log('WATCHER: selection.price_: ' + oldVal + ' => ' + newVal)
        newVal = this.priceNum(newVal)
        oldVal = this.priceNum(oldVal)
//        console.log('WATCHER: selection.price: ' + oldVal + ' => ' + newVal)
        if (newVal > oldVal) {
          doUpdate = true
        } else if (newVal < oldVal) {
          doUpdate = true
        }
        if (doUpdate && this.currentBetSlipState < this.stateLimitToUpdate) {
          Vue.set(this.selection, 'price', this.liveSelection.price)
          Vue.set(this.selection, 'currentpriceup', this.liveSelection.currentpriceup)
          Vue.set(this.selection, 'currentpricedown', this.liveSelection.currentpricedown)
//          store.dispatch('sbBetslipState/setBetSlipChange', {key: 'price', id: this.selectionId})
          //
          if (this.isLive && !this.isLivePush) {
//            console.log('Update BS if Live updated ' + oldVal + ' => ' + newVal)
            store.dispatch('sbBetslipState/scheduleBetSlipUpdate', 0.3)
          }
        }
      },

      isclosed (newVal) {
//        console.log('Watch: isclosed: ' + newVal)
        if (this.currentBetSlipState < this.stateLimitToUpdate && typeof newVal === 'boolean') {
          store.dispatch('sbBetslipState/setBetSlipChange', {key: 'closed', id: this.selectionId, remove: !newVal})
        }
      },
      issuspended (newVal) {
//        console.log('Watch: issuspended: ' + newVal)
        if (this.currentBetSlipState < this.stateLimitToUpdate && typeof newVal === 'boolean') {
          store.dispatch('sbBetslipState/setBetSlipChange', {key: 'suspended', id: this.selectionId, remove: !newVal})
        }
      },
      isNr (newVal) {
//        console.log('Watch: NR: ' + newVal)
        if (this.currentBetSlipState < this.stateLimitToUpdate && typeof newVal === 'boolean') {
          store.dispatch('sbBetslipState/setBetSlipChange', {key: 'NR', id: this.selectionId, remove: !newVal})
        }
      },
      nr (newVal) {
//        console.log('Watch: NR: ' + newVal)
        if (this.currentBetSlipState < this.stateLimitToUpdate && typeof newVal === 'boolean') {
          Vue.set(this.selection, 'idfobolifestate', newVal ? 'NR' : '')
        }
      },
      closed (newVal) {
//        console.log('Watch: closed: ' + newVal)
        if (this.currentBetSlipState < this.stateLimitToUpdate && typeof newVal === 'boolean') {
          Vue.set(this.selection, 'isclosed', newVal)
//          store.dispatch('sbBetslipState/setBetSlipChange', {key: 'closed', id: this.selectionId, remove: !newVal})
        }
      },
      suspended (newVal) {
//        console.log('Watch: suspended: ' + newVal)
        if (this.currentBetSlipState < this.stateLimitToUpdate && typeof newVal === 'boolean') {
          Vue.set(this.selection, 'istradable', !newVal)
//          store.dispatch('sbBetslipState/setBetSlipChange', {key: 'suspended', id: this.selectionId, remove: !newVal})
        }
      },

      currenthandicapLocal (newVal, oldVal) {
//        console.log('WATCHER: selection.currenthandicap: ' + oldVal + ' => ' + newVal)
        var self = this
        var doUpdate = false
        if (newVal > oldVal) {
          doUpdate = true
          self.hcpUp = true
          self.hcpDown = false
        } else if (newVal < oldVal) {
          doUpdate = true
          self.hcpUp = false
          self.hcpDown = true
        } else {
          self.hcpUp = false
          self.hcpDown = false
        }
        if (doUpdate && this.currentBetSlipState < this.stateLimitToUpdate) {
          store.dispatch('sbBetslipState/setBetSlipChange', {key: 'currenthandicap', id: this.selectionId})
          store.dispatch('sbBetslipState/getTeaserGroups', self.selection)
        }
      },
      currenthandicap (newVal, oldVal) {
//        console.log('WATCHER: selectionLIVE.currenthandicap: ' + oldVal + ' => ' + newVal)
        var doUpdate = false
        if (newVal > oldVal) {
          doUpdate = true
        }
        if (newVal < oldVal) {
          doUpdate = true
        }
        if (this.selection && doUpdate && this.currentBetSlipState < this.stateLimitToUpdate) {
          Vue.set(this.selection, 'currenthandicap', this.liveSelection.currenthandicap)
//          store.dispatch('sbBetslipState/setBetSlipChange', {key: 'currenthandicap', id: this.selectionId})
        }
      }
    },

    created () {
//      console.log('BetSlip selection created')
      var self = this
      clearTimeout(this.intKillHlite)
      this.intKillHlite = setTimeout(function () {
        self.killNewHlite()
      }, this.killHliteAfter * 1000)
      //
      if (this.multiSinglesStake) {
        Vue.set(this.betTypeStakes, this.selection.idfoselection, this.multiSinglesStake)
      }
      setTimeout(function () {
        store.dispatch('sbBetslipState/setBetSlipChange', {key: 'closed', id: self.selectionId, remove: !self.closed})
        store.dispatch('sbBetslipState/setBetSlipChange', {
          key: 'suspended',
          id: self.selectionId,
          remove: !self.suspended
        })
        store.dispatch('sbBetslipState/setBetSlipChange', {
          key: 'NR',
          id: self.selectionId,
          remove: !self.nr
        })
      }, 100)
    },

    destroyed () {
//      console.log('intKillHlite')
      clearTimeout(this.intKillHlite)
    }
  }
</script>

<style lang="stylus" scoped>
@import "~@/css/config"
  .selection {
    background-color: #fff;
    border: 1px solid #CFD6DB;
    border-radius: 5px;
    padding: 0px;
    margin: 7px 0;


    .event-name-inner,
    .event-name {
      color: #06283b;
      font-weight: bold;
      font-size: 14px
      line-height: 1;
      display: flex;

      .eventname {
        /*white-space: nowrap;*/
        span {
          display: inline-block;
        }
        span:empty {
          display: none;
        }
      }

      .name {
        flex-grow: 1;
      }

      .isLive {
        flex-shrink: 0;
      }

      + .selection-name {
        margin-top: 5px;
      }
      .icon {
        position: relative;
        width: 16px;
        margin-right: 5px;
        margin-top: -3px;
        .igt-icon {
          position: absolute;
          top: 2px;
        }
      }
    }

    .event-name {
      line-height: 1;
      padding: 10px 12px;
      /*background-color: #F0F3F8;*/
      background-color: #FFF;
      border: 0px solid #CCC;
      border-radius: 5px 5px 0 0;
      border-bottom-width: 1px;
      display: flex
      align-items: center

      > span {
         flex: 1
         flex-basis: auto
      }

      .igt-icon,
      .isLive {
        flex-grow: 0
      }

      .isLive {
        flex-basis: auto
      }

      .igt-icon {
        margin-right: 12px
      }

    }

    .columns {
      padding: 10px 12px;
      border-radius: 0 0 5px 5px;
      display: flex;
      align-items: center;
    }

    .stake-n-return {
      padding: 2px 5px 5px
      border-radius: 0 0 5px 5px;
    }
  }

  .TEASER.mixedTeasers {
    .selection {
      .event-name-inner {
        .icon {
          position: relative;
          width: 16px;
          margin-right: 5px;
          margin-top: -3px;
          .igt-icon {
            position: absolute;
            top: 2px;
          }
        }
      }
    }
  }

  .RR {
    .columns {
      padding-top: 8px;
    }
    .selection {
      margin: 0px !important;
      border-radius: 0px;
    }
    .bsSelection:first-child {
      .selection {
        margin: 0;
        border-radius: 5px 5px 0 0;
        border-top: 1px solid #cfd6db !important;
      }
    }
    .bsSelection.isSuspended:first-child {
      .selection {
        border-top: 1px solid #ea913c !important;
      }
    }
    .bsSelection:last-child {
      .selection {
        margin: 0;
        border-top: 0;
        // border-radius: 0 0 5px 5px;
      }
    }
    .bsSelection.isSuspended:last-child, .bsSelection.isClosed:last-child {
      .selection {
        border-top: 1px solid #ea913c !important;
      }
    }
    .bsSelection:first-child:last-child {
      .selection {
        margin: 0;
        // border-radius: 5px;
      }
    }
  }

  .TEASER {
    .columns {
      padding-top: 8px;
    }
    .selection {
      margin: 0px !important;
      border-radius: 0px;
    }

    .teaserSelection.first {
      .selection {
        margin: 0;
        // border-radius: 5px 5px 0 0;
      }
    }
    .teaserSelection.last {
      .selection {
        margin: 0;
        // border-radius: 0 0 5px 5px;
      }
    }
    .sport-container.info-msg-on {
      .teaserSelection.last {
        .selection {
          border-radius: 0px !important;
        }
      }
    }
    .teaserSelection.first.last {
      .selection {
        margin: 0;
        border-radius: 5px;
      }
    }
  }

  .columns {
    clear: both;
  }
  .column-left {
    display: none;
  }
  .column-right {
    display: block;
    flex: 1;
  }

  .RR.review,
  .edit {
    .column {
      display: inline-block;
    }
  }

  .RR.edit,
  .RR.review,
  .TEASER.edit,
  .TEASER.review{
    .column {
      display: inline-block;
      flex: 1
      // flex-basis: auto
      align-items: center
    }

    .column-left{
      flex-grow: 0
      flex-basis: auto;
      margin-right: 12px

    }

    .column-teaser {
      font-weight: bold;
      width: 12%;
      vertical-align: top;
      text-align: right;
    }

  }


  .isLive {
    float: right;
    color: #db3f3f;
    /*color: #fff;*/
    /*padding: 1px 4px;*/
    border-radius: 3px;
    font-size: 12px;
  }
  .isLive:before{
    content: "";
    display: inline-block;
    background-color: #db3f3f;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    vertical-align: middle;
    margin-right: 3px;
    margin-top: -2px;
  }

  .bsSelection:first-child {
    /*border-top: 1px solid silver;*/
  }

  .bsSelection {
    position: relative;
    /*border-bottom: 1px solid silver;*/
    padding: 0;
    .btnX {
      margin-right: 12px

      .igt-icon {
        >>> .css {
          width: 18px
          height: 20px
        }
      }
    }

    .selection-data, .selection-price, .selection-ts {
      /*display: inline-block;*/
      // overflow-x: hidden;
      padding: 0;
      border-width: 0;
      text-align: center;
      vertical-align: middle;
    }


    .selection-data {
      text-align: left;
      line-height: 1.3

      .market-name {
        text-transform: uppercase;
        color: #818e95;
        margin-top: 2px
      }
      .event-name { }
      .name { color: #06283b; }
      .available-for-bb {
        display inline-block
        width 17px
        height 17px
        background-repeat no-repeat
        position relative
        top 3px
      }
    }

    .selection-price {
      color: #1493FF;
      display: inline-block;
      float: right;
      font-size: 14px
      .lock {
        display: none;
      }
    }

    .selection-ts {
      font-size: 90%;
      .time {
        display: inline-block;
        background-color: #9e864d;
        color: white;
        padding: 5px 3px;
        margin-bottom: 1px;
        white-space: nowrap;
      }
      .date {
        display: inline-block;
        padding: 3px 3px;
      }
    }
    input {
      /*width: 80px;*/
      background-color: #fff;
      text-align: center;
    }
  }

  .REGULAR .selection-name {
    font-weight: bold;
  }

  .selection-name {
    clear: both;
  }
  .priceUp {
    .selection-price {
      background-color: #D7F3E0;
      color: #2CB459;
      font-weight: 600;
      padding: 3px;
      border-radius: 4px;
    }
  }

  .priceUp .selection-price:before{
    // position: relative;
    // content: url(icons-path'/price-up-small.svg');
    // margin: 6px 4px;
    font-family: 'Material Icons';
    font-weight: normal;
    font-style: normal;
    font-size: 24px;
    line-height: 1;
    letter-spacing: normal;
    text-transform: none;
    display: inline-block;
    white-space: nowrap;
    word-wrap: normal;
    direction: ltr;
    -webkit-font-feature-settings: 'liga';
    -webkit-font-smoothing: antialiased;
    font-feature-settings: 'liga';
    // material-icons()
    position: relative;
    content: 'arrow_drop_up';
    display: inline-block;
  }

  .priceDown {
    .selection-price {
      background-color: #FCECEC;
      color: #DB3F3F;
      font-weight: 600;
      padding: 3px;
      border-radius: 4px;
    }
  }
  .priceDown .selection-price:before{
    font-family: 'Material Icons';
    font-weight: normal;
    font-style: normal;
    font-size: 24px;
    line-height: 1;
    letter-spacing: normal;
    text-transform: none;
    display: inline-block;
    white-space: nowrap;
    word-wrap: normal;
    direction: ltr;
    -webkit-font-feature-settings: 'liga';
    -webkit-font-smoothing: antialiased;
    font-feature-settings: 'liga';
    // material-icons()
    position: relative
    content: 'arrow_drop_down'
    display: inline-block
  }



  .bsSelection.hliteNew {
    background-color: #dcffff
  }


  .inRefferalStakeChanged
    .selection
      border-style: solid
      border-color: #EA913C
      border-width: 1px !important
      margin-top: -1px !important
      .event-name
        background-color: #FFF2E5
        color: #EA913C

  .RR
    .isClosed
    .isSuspended
    .isNR
      .selection
        border-style: solid
        border-color: #EA913C
        border-width: 1px !important
        background-color: #FFF2E5
        padding-left: 5px;
        margin-top: -1px !important
        .checkbox
          color: #EA913C !important
        .overlayCS
          height: 0
        .name
        .event-name
        .market-name
        >>>.money-input
            opacity: 0.5

  .TEASER
    .isClosed
    .isSuspended
    .isNR
      .selection
        border-style: solid !important
        border-color: #EA913C !important
        border-width: 1px !important
        background-color: #FFF2E5 !important
        margin: -1px !important;
        padding-left: 5px;
        .checkbox
          color: #EA913C !important
        .overlayCS
          height: 0


  .REGULAR
    .isClosed
    .isSuspended
    .isNR
      .selection
        border-style: solid
        border-color: #EA913C
        border-width: 1px !important
        // background-color: #FFF2E5
        .name
        .market-name
        >>>.money-input
            opacity: 0.5
        .event-name
          background-color: #FFF2E5
          border-bottom: 1px solid #EA913C

  .optedOut
    .selection
      background-color: #fff !important

  .isClosed .selection-price .price,
  .isClosed.isSuspended .selection-price .price,
  .isSuspended .selection-price .price
  .isNR .selection-price .price
    display: none

  .isClosed .selection-price .lock,
  .isClosed.isSuspended .selection-price .lock,
  .isSuspended .selection-price .lock
  .isNR .selection-price .lock
    display: inline-block
    color: #fff
    background-color: #EA913C
    padding: 7px 12px
    border-radius: 4px 0 0 4px
    position: absolute
    right: 0
    font-weight: normal

  .bsSelection:not(.S):not(.isClosed):not(.isSuspended):not(.isNR).interRelated-1
  .bsSelection:not(.S):not(.isClosed):not(.isSuspended):not(.isNR).interRelated-2
  .bsSelection:not(.S):not(.isClosed):not(.isSuspended):not(.isNR).interRelated-3
  .bsSelection:not(.S):not(.isClosed):not(.isSuspended):not(.isNR).interRelated-4
  .bsSelection:not(.S):not(.isClosed):not(.isSuspended):not(.isNR).interRelated-5
  .bsSelection:not(.S):not(.isClosed):not(.isSuspended):not(.isNR).interRelated-6
  .bsSelection:not(.S):not(.isClosed):not(.isSuspended):not(.isNR).interRelated-7
  .bsSelection:not(.S):not(.isClosed):not(.isSuspended):not(.isNR).interRelated-8
    .selection
      border-color: #31A0FD
      .event-name
      // .event-name-inner
        border-color: #31A0FD
        background-color: #E5F3FF

  .RR
  .TEASER
    .bsSelection:not(.S):not(.isClosed):not(.isSuspended):not(.isNR).interRelated-1
    .bsSelection:not(.S):not(.isClosed):not(.isSuspended):not(.isNR).interRelated-2
    .bsSelection:not(.S):not(.isClosed):not(.isSuspended):not(.isNR).interRelated-3
    .bsSelection:not(.S):not(.isClosed):not(.isSuspended):not(.isNR).interRelated-4
    .bsSelection:not(.S):not(.isClosed):not(.isSuspended):not(.isNR).interRelated-5
    .bsSelection:not(.S):not(.isClosed):not(.isSuspended):not(.isNR).interRelated-6
    .bsSelection:not(.S):not(.isClosed):not(.isSuspended):not(.isNR).interRelated-7
    .bsSelection:not(.S):not(.isClosed):not(.isSuspended):not(.isNR).interRelated-8
      .selection
        border-color: #CFD6DB
        border-width:0px 1px  1px 0px
        border-left: 5px solid #31A0FD
        .event-name
        // .event-name-inner
          border-color: #31A0FD
          background-color: #E5F3FF
    .bsSelection:not(.S):not(.isClosed):not(.isSuspended):not(.interRelated-1):not(.interRelated-2):not(.interRelated-3):not(.interRelated-4):not(.interRelated-5):not(.interRelated-6):not(.interRelated-7):not(.interRelated-8)
      .selection
        padding-left: 5px
        .header-changed
          margin-left: -5px

  .S .stake-line {
    display: block;
  }

  .S.multiSingles .stake-line {
    /*display: none;*/
  }
  .arrow-up
    display: inline-block
    width: 0
    height: 0
    border-left: 5px solid transparent
    border-right: 5px solid transparent
    border-bottom: 9px solid green

  .arrow-down
    display: inline-block
    width: 0
    height: 0
    border-left: 5px solid transparent
    border-right: 5px solid transparent
    border-top: 9px solid #f00

  .overlayCS
    color: white
    text-align: center
    vertical-align: middle
    .contentCS
      display: inline-block
      width: 100%
      .selection-status
        background-color: #EA913C
        padding: 6px 12px
        border-radius: 4px 0 0 4px
        position: absolute
        bottom: 0px
        top: 0
        right: 0
        margin: auto
        height: 32px
        font-weight: normal

  .header-changed
    padding: 8px 12px !important
    font-size: 13px!important;
    border-radius: inherit !important
    border-bottom-right-radius: 0 !important
    border-bottom-left-radius: 0 !important
    border-width: 0 !important
    border-bottom-width: 1px !important
    margin-left: 0px

  .changed {
    .selection {
      border-color: #4cadff !important;
      .event-name {
        border-color: #4cadff !important;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/sports/betslip/betslipSelection.vue